import { kioskCommand } from 'api/Kiosk';

import { showAlert } from 'components/shared/Alert/Alert';

import { invalidatePaymentQueries } from './paymentQueryKeys';

export const KIOSK_RESULT_ALERTS = {
  success: {
    color: 'success',
    icon: 'money-receive-mono',
    title: 'Payment received',
    message: 'The kiosk finished the payment.'
  },
  canceled: {
    color: 'warning',
    title: 'Payment canceled',
    message: 'The payment was canceled on the kiosk.'
  },
  'packet-complete': {
    color: 'warning',
    title: 'Forms completed, no payment collected',
    message: 'The patient finished the forms on the kiosk, but no payment was taken.'
  },
  unconfirmed: {
    color: 'warning',
    title: 'Payment not confirmed',
    message:
      "The kiosk finished without reporting a payment. Check the patient's ledger before charging again."
  },
  error: {
    color: 'danger',
    title: 'Payment not received',
    message: "The kiosk couldn't finish the payment."
  },
  timeout: {
    color: 'warning',
    title: 'Still waiting on the kiosk',
    message:
      "The kiosk hasn't reported an outcome yet. We're still listening — cancel the request if the patient isn't paying."
  }
};

export const CANCELED_REQUEST_ALERT = {
  color: 'success',
  variant: 'light',
  title: 'Payment request canceled',
  message: 'The kiosk payment request was canceled.'
};

const ABANDONED_CANCEL_FAILED_ALERT = {
  color: 'danger',
  variant: 'light',
  title: "Couldn't cancel the kiosk payment",
  message:
    "The kiosk may still be waiting for the patient. Check the kiosk and the patient's ledger before charging again."
};

export const invalidateKioskPaymentQueries = (queryClient) => {
  invalidatePaymentQueries(queryClient);
  queryClient.invalidateQueries({ queryKey: ['activities'] });
};

export const releaseAbandonedKioskRequest = async ({ navigate, queryClient, kioskId }) => {
  const res = await kioskCommand(navigate, { kioskId, command: 'payment-cancel' }).catch(
    () => null
  );

  if (res?.transaction?.completed) {
    invalidateKioskPaymentQueries(queryClient);
    showAlert({ variant: 'light', ...KIOSK_RESULT_ALERTS.success });
    return;
  }

  if (res?.code !== 0) {
    showAlert(ABANDONED_CANCEL_FAILED_ALERT);
    return;
  }

  await kioskCommand(navigate, { kioskId, command: 'idle' }).catch(() => null);
  showAlert(CANCELED_REQUEST_ALERT);
};
